import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { EnterpriseHub } from './pages/EnterpriseHub';
import { PostSignin } from './pages/PostSignin';
import { Profile } from './pages/Profile';
import { Welcome } from './pages/Welcome';
import { Terms } from './pages/Terms';
import { ProtectedRoute } from './components/ProtectedRoute';
import { TermsGate } from './components/TermsGate';
import { NameGate } from './components/NameGate';
import { ENTERPRISE_URL } from './lib/scenarioNav';
import { ResolvedScenario } from './pages/enterprise-hub/ResolvedScenario';
import { PROFILE_NAV_ITEMS, PROFILE_URL } from './lib/profileNav';
import { ProfileIndexRedirect } from './pages/profile/ProfileIndexRedirect';
import { StaffConsole, StaffIndexRedirect } from './pages/staff/StaffConsole';
import { StaffCatalogue } from './pages/staff/StaffCatalogue';
import { StaffOrganisations } from './pages/staff/StaffOrganisations';
import { STAFF_URL } from './staff/staffNav';
import { useTrialIntentRelease } from './hooks/useTrialIntentRelease';



export default function App() {
  useTrialIntentRelease();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/post-signin" element={<PostSignin />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/terms" element={<Terms />} />
        <Route element={<NameGate />}>
          {/* TermsGate wraps only the Hub subtree, so members' and staff routes are never gated. */}
          <Route element={<TermsGate />}>
            <Route path={ENTERPRISE_URL} element={<EnterpriseHub />}>
              <Route index element={<ResolvedScenario />} />
              {/* Old per-scenario URLs (bookmarks) land on the resolved page. */}
              <Route path="*" element={<Navigate to={ENTERPRISE_URL} replace />} />
            </Route>
          </Route>
        </Route>
        <Route path={PROFILE_URL} element={<Profile />}>
          <Route index element={<ProfileIndexRedirect />} />
          {PROFILE_NAV_ITEMS.map((item) => {
            const { Element, segment } = item;
            return <Route key={segment} path={segment} element={<Element />} />;
          })}
        </Route>
        <Route path={STAFF_URL} element={<StaffConsole />}>
          <Route index element={<StaffIndexRedirect />} />
          <Route path="catalogue/:productId" element={<StaffCatalogue />} />
          <Route path="organisations" element={<StaffOrganisations />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
